// @ts-nocheck
import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Box, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Menu, Item, Submenu } from 'react-contexify';

import 'react-contexify/dist/ReactContexify.css';
import PropTypes from 'prop-types';
import { EMPTY_ARRAY, EMPTY_OBJECT, NOOP } from '../../const/CommonConst';

const StyledMenu = styled(Menu)(({ theme }) => ({
  ...theme?.palette?.contextMenu?.menu,
  zIndex: '9999 !important',
}));

const RecursiveMenu = ({
  menus = EMPTY_ARRAY,
  menuId,
  onMenuClick,
  isSubMenu = false,
  subMenuDetails = null,
  _additionalData = null,
  trackVisibility = undefined,
}) => {
  const theme = useTheme();
  return isSubMenu ? (
    <Submenu
      label={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {subMenuDetails.icon ? (
            <subMenuDetails.icon
              style={{
                color: theme?.palette?.primary?.main,
                width: 18,
                height: 18,
              }}
            />
          ) : null}
          <Box
            sx={{
              ml: 2,
              display: 'flex',
              flexGrow: 1,
            }}
          >
            <Typography>{subMenuDetails?.label}</Typography>
          </Box>
        </Box>
      }
      disabled={subMenuDetails?.isMenuDisabled}
    >
      {menus.map((menu, _index) =>
        menu.subMenus?.length ? (
          <RecursiveMenu
            menus={menu.subMenu}
            isSubMenu={true}
            onMenuClick
            menuId
            key={`${menu.id}_${menu.label}`}
          />
        ) : (
          <Item
            id={menu.id}
            onClick={onMenuClick}
            key={`${menu.id}_${menu.label}`}
            data={menu}
            disabled={menu.isMenuDisabled}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {menu?.icon ? (
                <menu.icon
                  style={{
                    color: theme?.palette?.primary?.main,
                    width: 18,
                    height: 18,
                  }}
                />
              ) : null}
              <Box
                sx={{
                  ml: 2,
                  display: 'flex',
                  flexGrow: 1,
                }}
              >
                <Typography>{menu.label}</Typography>
              </Box>
            </Box>
          </Item>
        )
      )}
    </Submenu>
  ) : (
    <StyledMenu
      id={menuId}
      onVisibilityChange={trackVisibility}
      animation="slide"
    >
      {menus.map((menu, _index) =>
        menu.subMenus?.length ? (
          <RecursiveMenu
            menus={menu.subMenus}
            isSubMenu={true}
            subMenuDetails={menu}
            onMenuClick={onMenuClick}
            menuId={menuId}
            key={`${menu.id}_${menu.label}`}
          />
        ) : (
          <Item
            id={menu.id}
            onClick={onMenuClick}
            data={menu}
            key={`${menu.id}_${menu.label}`}
            disabled={menu.isMenuDisabled}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {menu?.icon ? (
                <menu.icon
                  style={{
                    color: theme?.palette?.primary?.main,
                    width: 18,
                    height: 18,
                  }}
                />
              ) : null}
              <Box
                sx={{
                  ml: 2,
                  display: 'flex',
                  flexGrow: 1,
                }}
              >
                <Typography>{menu.label}</Typography>
              </Box>
            </Box>
          </Item>
        )
      )}
    </StyledMenu>
  );
};

RecursiveMenu.propTypes = {
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      icon: PropTypes.elementType,
      isMenuDisabled: PropTypes.bool,
      subMenus: PropTypes.arrayOf(PropTypes.shape({})),
      subMenu: PropTypes.arrayOf(PropTypes.shape({})),
      onClick: PropTypes.func,
    })
  ),
  menuId: PropTypes.string.isRequired,
  onMenuClick: PropTypes.func.isRequired,
  isSubMenu: PropTypes.bool,
  subMenuDetails: PropTypes.shape({
    icon: PropTypes.elementType,
    label: PropTypes.string,
    isMenuDisabled: PropTypes.bool,
  }),
  _additionalData: PropTypes.shape({}),
  trackVisibility: PropTypes.func,
};

export default RecursiveMenu;

export const ContextMenus = ({
  menus = EMPTY_ARRAY,
  additionalData = EMPTY_OBJECT,
  handleMenuClick = undefined,
  menuId,
  onMenuExit = NOOP,
  renderInPortal = false,
  portalContainer = undefined,
}) => {
  // do not remove this
  // you can use this hook from everywhere. All you need is the menu id
  // const { show } = useContextMenu({
  //   id: menuId,
  // });

  const handleItemClick = useCallback(
    (menuClickEventData) => {
      if (handleMenuClick) {
        handleMenuClick(menuClickEventData);
      } else {
        menuClickEventData.data?.onClick(menuClickEventData);
      }
    },
    [handleMenuClick]
  );
  const trackVisibility = useCallback(
    (isVisible) => {
      if (!isVisible) {
        onMenuExit();
      }
    },
    [onMenuExit]
  );
  // do not remove this
  // function displayMenu(e) {
  //   // put whatever custom logic you need
  //   // you can even decide to not display the Menu
  //   show({
  //     id: menuId,
  //     event: e,
  //     props: { ...additionalData },
  //   });
  // }
  // {/* <div onContextMenu={displayMenu}>Right click inside the box</div> */
  //   <Menu id={MENU_ID}>
  //         <Item onClick={handleItemClick}>Item 1</Item>
  //         <Item onClick={handleItemClick}>Item 2</Item>
  //         <Separator />
  //         <Item disabled>Disabled</Item>
  //         <Separator />
  //         <Submenu label="Submenu">
  //           <Item onClick={handleItemClick}>Sub Item 1</Item>
  //           <Item onClick={handleItemClick}>Sub Item 2</Item>
  //         </Submenu>
  //       </Menu> */
  //    */}
  const menu = (
    <RecursiveMenu
      menus={menus}
      onMenuClick={handleItemClick}
      menuId={menuId}
      isSubMenu={false}
      additionalData={additionalData}
      trackVisibility={trackVisibility}
    />
  );

  const resolvedPortalContainer =
    portalContainer || (typeof document !== 'undefined' ? document.body : null);

  if (renderInPortal && resolvedPortalContainer) {
    return createPortal(menu, resolvedPortalContainer);
  }

  return menu;
};

ContextMenus.propTypes = {
  menus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
      icon: PropTypes.elementType,
      isMenuDisabled: PropTypes.bool,
      subMenus: PropTypes.arrayOf(PropTypes.shape({})),
      subMenu: PropTypes.arrayOf(PropTypes.shape({})),
      onClick: PropTypes.func,
    })
  ),
  additionalData: PropTypes.shape({}),
  handleMenuClick: PropTypes.func,
  menuId: PropTypes.string.isRequired,
  onMenuExit: PropTypes.func,
  renderInPortal: PropTypes.bool,
  portalContainer: PropTypes.instanceOf(Object),
};
